import visaLogo from 'src/redesign/assets/icons/visaLogo.png';
import { MasterCardLogo } from 'src/redesign/assets/icons';
import { Image } from 'wix-style-react';
import amexLogo from 'src/redesign/assets/icons/amexLogo.png';

export function getPaymentLogo(paymentCard: string) {
  const paymentsLogos = {
    visa: (
      <img
        style={{ width: '40px', height: '40px', objectFit: 'contain' }}
        src={visaLogo}
        alt="visa"
      />
    ),
    mastercard: <MasterCardLogo />,
    american_express: <Image width="40px" src={amexLogo} alt="amex" />,
  };

  return paymentsLogos[paymentCard];
}
